<div class="group-field-dropdown-box">
  <div class="control">
    <div
      class="select select--simulate"
      [class.is-danger]="isInitiativeTypeFieldError()"
      [class.is-focus]="isOpen() && hasData()"
      [class.is-disabled]="isDisabled()"
      (click)="toggleDropdown()"
    >
      {{ selectedLabel() }}
    </div>

    <!-- Dropdown menu -->
    @if (isOpen() && hasData()) {
    <div class="box mb-auto pb-4" [ngClass]="{ 'is-disabled': isDisabled() }">
      @for (group of groupedData() | keyvalue; track group.key) {
      <!-- Group title -->
        @if (group.key !=='null') {
          <div class="px-4 py-2 has-background-light">
            <strong class="category-title">{{ group.key }}</strong>
          </div>
        }

      <!-- Group options -->
        @for (item of group.value; track getItemLabel(item)) {
          <div class="control px-7 py-1 is-fullwidth item">
            <a
              class="dropdown-item-link"
              [class.is-active]="isItemSelected(item)"
              (click)="selectItem(item)"
            >
              {{ getItemLabel(item) }}
            </a>
          </div>
        }

      <!-- Divider between groups -->
        @if ($index < (groupedData() | keyvalue).length - 1) {
          <hr class="my-3" />
        } 
      } @empty {
        <div class="px-4 py-2 has-text-grey">No options available</div>
      }

      <!-- Empty state -->
      @if (!hasData()) {
        <div class="px-4 py-2 has-text-grey">No options available</div>
      }
    </div>
    }
  </div>
</div>
